import OrderBuylist from "./components/OrderBuylist";

const BuyerOrder = () => {
  return (
    <div
      className="flex flex-col min-h-screen"
      style={{ background: "#f8fafa !important" }}
    >
      <div className="xs:flex xs:flex-col items-right ">
        <OrderBuylist />
      </div>
    </div>
  );
};

export default BuyerOrder;
